import axiosInstance from '../../../axiosInstance';
import { notify } from '../../../../utils/notification';

// Shared plumbing for the VMS request modules.
//
// Every VMS route runs Joi in non-stripping mode, so an unexpected key is a 400
// rather than a silently ignored field. Params and bodies are therefore built
// from explicit whitelists and emptied of blanks before they go out.

export const clean = (obj) => {
    const out = {};
    Object.entries(obj || {}).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
};

// Validation failures bypass the API's response helper and arrive as
// { status: 'error', message: 'body: "x" is required' } rather than the usual
// { success: false, message }. Both carry `message`, so one reader covers them.
export const errMessage = (err, fallback) =>
    err?.response?.data?.message || err?.message || fallback;

export const url = (template, params = {}) =>
    Object.entries(params).reduce((acc, [k, v]) => acc.replace(`:${k}`, v), template);

// Controllers scope lists on req.query.society_id and fall back to
// req.societyId, which the backend never assigns — so the X-Society-Id header
// authorises the call but does NOT scope the rows. society_id has to ride in
// the query explicitly or the list leaks every society's records.
export const listParams = (data, extra = {}) => clean({
    society_id: data?.societyId,
    page: data?.page || 1,
    limit: data?.limit || 10,
    ...extra,
});

// `id` belongs in the path and the callbacks are client-side only, so neither
// may reach the request body.
export const bodyOf = (data, omit = []) => {
    const { id, onSuccess, onError, societyId, ...rest } = data || {};
    omit.forEach(k => { delete rest[k]; });
    return rest;
};

export const getReq = (endpoint, params, fallbackMsg) =>
    axiosInstance.get(endpoint, { params })
        .then(res => res)
        .catch((err) => {
            notify('error', errMessage(err, fallbackMsg));
            return err;
        });

// Mutations announce themselves; reads stay quiet unless they fail.
export const writeReq = (method, endpoint, payload, successMsg, fallbackMsg) =>
    axiosInstance[method](endpoint, payload)
        .then(res => {
            if (res?.success) notify('success', res.message || successMsg);
            return res;
        })
        .catch((err) => {
            notify('error', errMessage(err, fallbackMsg));
            return err;
        });
